import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { io } from "socket.io-client";

import { Container, Image } from "react-bootstrap";

import ComponentMenu from "../../components/layout/ComponentMenu";
import appairage from "../../assets/images/appairage.jpg";

const PageFlashCode = () => {
  const { ReduxToken } = useSelector((state) => state.ReduxToken);

  /* Connexion au socketIO et initialisation de la room de discussion */
  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const flashCodeRoom = params.get("room");

    /* On ouvre la connexion Socket */
    const socket = io(process.env.REACT_APP_URL_SOCKETIO);
    /* on rejoint la meme room que celle proposée par le flashCode page login */
    socket.emit("joinRoom", flashCodeRoom);
    /* on transfere le token de securite via privateRoom */
    socket.emit("transferToken", {
      privateRoom: flashCodeRoom,
      token: ReduxToken,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ComponentMenu />
      <Container>
        <div className="text-center m-5">
          <Image src={appairage} className="w-75" />
        </div>
      </Container>
    </>
  );
};

export default PageFlashCode;
